/** Tokens visuais — formulário de produto (marca TNV) */
export const PRODUTO_FORM_ACCENT = "#F96030";
export const PRODUTO_FORM_INK = "#1a2035";

export const produtoToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${PRODUTO_FORM_ACCENT}`,
};

export const produtoTabsSx = {
  mb: 2,
  minHeight: 48,
  borderBottom: "1px solid",
  borderColor: "grey.200",
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 600,
    minHeight: 48,
  },
  "& .Mui-selected": {
    color: `${PRODUTO_FORM_ACCENT} !important`,
  },
  "& .MuiTabs-indicator": {
    backgroundColor: PRODUTO_FORM_ACCENT,
    height: 3,
  },
};

export const sectionPanelSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  overflow: "hidden",
  bgcolor: "background.paper",
  mb: 2,
};

export const sectionHeaderSx = {
  px: 3,
  py: 2,
  bgcolor: "grey.50",
  borderBottom: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${PRODUTO_FORM_ACCENT}`,
};

export const formFieldsWrapperSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 52,
  },
  "& .MuiOutlinedInput-input": {
    py: 1.5,
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "grey.500",
    borderWidth: 1,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "text.secondary",
  },
};

/** Selects do drawer — mesma altura dos FormField (52px). */
export const drawerSelectControlSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: 52,
    height: 52,
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    py: 1.5,
    boxSizing: "border-box",
  },
  "& .MuiInputLabel-root": {
    transform: "translate(14px, 14px) scale(1)",
    "&.MuiInputLabel-shrink": {
      transform: "translate(14px, -9px) scale(0.75)",
    },
  },
};

export const emptyStateSx = {
  py: 4,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${PRODUTO_FORM_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxWidth: 440,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  background: `linear-gradient(135deg, ${PRODUTO_FORM_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${PRODUTO_FORM_ACCENT}`,
};

export const switchAccentSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: PRODUTO_FORM_ACCENT },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    bgcolor: PRODUTO_FORM_ACCENT,
  },
};

export const DRAWER_WIDTH = 520;

export const drawerPaperSx = {
  width: DRAWER_WIDTH,
  maxWidth: "100vw",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  borderLeft: "1px solid",
  borderColor: "grey.200",
  boxShadow: "none",
};

export const drawerSectionSx = {
  border: "1px solid",
  borderColor: "grey.200",
  borderRadius: 2,
  overflow: "hidden",
  bgcolor: "background.paper",
};

export const drawerSectionHeaderSx = {
  px: 2,
  py: 1.25,
  bgcolor: "grey.50",
  borderBottom: "1px solid",
  borderColor: "grey.200",
};

export const drawerFooterSx = {
  px: 2.5,
  py: 2,
  flexShrink: 0,
  borderTop: "1px solid",
  borderColor: "grey.200",
  bgcolor: "grey.50",
};

export const toggleCardSx = (active: boolean) => ({
  width: "100%",
  p: 1.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: active ? "rgba(249, 96, 48, 0.45)" : "grey.200",
  bgcolor: active ? "rgba(249, 96, 48, 0.05)" : "background.paper",
  transition: "border-color 0.2s ease, background-color 0.2s ease",
  "& .MuiFormControlLabel-root": {
    width: "100%",
    justifyContent: "space-between",
    ml: 0,
  },
});
